import { useContext } from 'react';
import { ThemeContext, type ThemeContextValue } from '@src/theme/ThemeContext';

export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme was called outside of <ThemeProvider>');
  }
  return context;
}
